module.exports = __webpack_public_path__ + "static/img/hdw3.ff19d0ee.jpg";